import { render, staticRenderFns } from "./ApplyToAllTextDropdown.vue?vue&type=template&id=a8b4b514&scoped=true"
import script from "./ApplyToAllTextDropdown.vue?vue&type=script&lang=js"
export * from "./ApplyToAllTextDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b4b514",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8b4b514')) {
      api.createRecord('a8b4b514', component.options)
    } else {
      api.reload('a8b4b514', component.options)
    }
    module.hot.accept("./ApplyToAllTextDropdown.vue?vue&type=template&id=a8b4b514&scoped=true", function () {
      api.rerender('a8b4b514', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/ApplyToAllTextDropdown.vue"
export default component.exports